import { render, staticRenderFns } from "./ConsignmentSummaryReport.vue?vue&type=template&id=326ba7e8&scoped=true"
import script from "./ConsignmentSummaryReport.vue?vue&type=script&lang=js"
export * from "./ConsignmentSummaryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ba7e8",
  null
  
)

export default component.exports